import { Injectable } from '@angular/core';
import { ApiService } from 'core/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class AccountsDetailService {

  private urlDetailsGetByCustomer = '/api/account/byCustomer/';
  private urlDetailsGetByLead = '/api/account/byLead/';

  constructor(
    private apiService: ApiService
  ) { }

  public getAccountDetailsByCustomer(contactId) {
    return this.apiService.get(this.urlDetailsGetByCustomer + contactId);
  }

  public getAccountDetailsByLead(leadId) {
    return this.apiService.get(this.urlDetailsGetByLead + leadId);
  }
}
